export default __webpack_public_path__ + "static/media/5.f007d1f1.png";